import type { TRuleWithTheme } from 'styles';

export const formItem: TRuleWithTheme = ({ theme }) => ({
    maxWidth: theme.form.formWrapperWidth,
});

export const select: TRuleWithTheme = () => ({});
